import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUser from './user.reducer';

// Lookup the 'uiStyle' feature state managed by NgRx
export const getUserState = createFeatureSelector<fromUser.UserState>(
  fromUser.USER_FEATURE_KEY
);

export const getUser = createSelector(
  getUserState,
  (state: fromUser.UserState) => state
);

export const getSelectedOrganizationInfo = createSelector(
  getUserState,
  (state: fromUser.UserState) =>
    state?.entities?.find((x) => x.id === state.selectedOrganizationId)
);

export const getUsersPermissionsForSelectedOrganization = createSelector(
  getUserState,
  (state: fromUser.UserState) =>
    state?.entities?.find((x) => x.id === state.selectedOrganizationId)
      ?.permissions || []
);

export const getUserLoaded = createSelector(
  getUserState,
  (state: fromUser.UserState) => state.loaded
);

export const getUserAccounts = createSelector(
  getUserState,
  (state: fromUser.UserState) => state.entities
);

export const getUserSupplierAccounts = createSelector(
  getUserState,
  (state: fromUser.UserState) =>
    state.entities.filter((x) => x.type.toString() === 'Supplier')
);

export const getUserConsumerAccounts = createSelector(
  getUserState,
  (state: fromUser.UserState) =>
    state.entities.filter((x) => x.type.toString() === 'Consumer')
);

export const getUserTraderAccounts = createSelector(
  getUserState,
  (state: fromUser.UserState) =>
    state.entities.filter((x) => x.type.toString() === 'Trader')
);

export const getUserBusinessAccounts = createSelector(
  getUserState,
  (state: fromUser.UserState) =>
    state.entities.filter((x) => x.type.toString() !== 'Consumer')
);

export const getSelectedSupplierId = createSelector(
  getUserState,
  (state: fromUser.UserState) => state.selectedOrganizationId
);
